import classNames from 'classnames';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { PropsWithChildren } from 'react';

export type RichTextBoxMenuType = 'dropdown';

export type RichTextBoxMenuProps = {
  attrs?: React.HTMLAttributes<HTMLDivElement>;
  label?: JSX.Element | string | null;
};

const InternalRichTextBoxMenu = React.forwardRef(
  (
    props: PropsWithChildren<RichTextBoxMenuProps>,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    const { children, attrs } = props;
    const { className, ...trimmedAttributes } = attrs ?? {
      className: undefined,
    };
    const newClassName = classNames('richtextbox-menu', className);
    return (
      <div ref={ref} className={newClassName} {...trimmedAttributes}>
        {children}
      </div>
    );
  },
);
InternalRichTextBoxMenu.displayName = 'Menu';
InternalRichTextBoxMenu.propTypes = {
  children: PropTypes.node,
};
export const RichTextBoxToolbarMenu = observer(InternalRichTextBoxMenu);
